module.exports = __webpack_public_path__ + "img/S5.4deb0ec8.png";